<h2 class="title" *ngIf="!hideTitle">
  <span *ngIf="!showCompanies">
    {{ "Login" | locale }}
  </span>
</h2>
<div class="login-form" *ngIf="!showCompanies">
  <nz-form-item>
    <nz-form-label nzFor="email" nzNoColon>
      {{ "Email" | locale }}
    </nz-form-label>
    <nz-input-group [nzPrefix]="userNameIcon">
      <input
        type="text"
        nz-input
        #emailControl
        [(ngModel)]="email"
        [placeholder]="'Email' | locale"
        (keydown)="submit($event)"
      />
    </nz-input-group>
    <ng-template #userNameIcon
      ><i nz-icon
        ><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 19.834">
          <path
            d="M216.621,480.14h19.655c.487-3.7-.255-5.069-3.546-6.383a16.314,16.314,0,0,0-12.909.145C216.76,475.21,215.977,476.731,216.621,480.14Zm9.826-19.834a4.423,4.423,0,0,0-4.464,4.453,4.442,4.442,0,0,0,8.883-.086A4.422,4.422,0,0,0,226.447,460.306Z"
            transform="translate(-216.412 -460.306)"
          /></svg></i
    ></ng-template>
  </nz-form-item>
  <nz-form-item>
    <nz-form-label nzFor="password" nzNoColon>
      {{ "Password" | locale }}
    </nz-form-label>
    <nz-input-group [nzPrefix]="passwordIcon">
      <input
        type="password"
        nz-input
        [(ngModel)]="password"
        [placeholder]="'Password' | locale"
        (keydown)="submit($event)"
      />
    </nz-input-group>
    <ng-template #passwordIcon
      ><i nz-icon
        ><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14.5 19.333">
          <path
            d="M233.4,548.39H232.19v-1.611a5.639,5.639,0,0,0-11.278,0v1.611H219.7a.4.4,0,0,0-.4.4v10.069a1.612,1.612,0,0,0,1.611,1.611H232.19a1.613,1.613,0,0,0,1.611-1.611V548.793A.4.4,0,0,0,233.4,548.39Zm-5.641,8.414a.4.4,0,0,1-.4.447h-1.611a.4.4,0,0,1-.4-.447l.254-2.285a1.592,1.592,0,0,1-.659-1.3,1.611,1.611,0,1,1,3.222,0,1.6,1.6,0,0,1-.659,1.3Zm2.016-8.414h-6.445v-1.611a3.222,3.222,0,0,1,6.445,0Z"
            transform="translate(-219.301 -541.14)"
          /></svg></i
    ></ng-template>
  </nz-form-item>
  <nz-space style="width: 100%" nzDirection="vertical">
    <nz-space-item *ngIf="conditionsText !== ''">
      <label nz-checkbox [(ngModel)]="acceptTerms"></label>&nbsp;&nbsp;<a
        [href]="conditionsLink"
        target="_blank"
        >{{ conditionsText }}</a
      >
    </nz-space-item>
    <nz-space-item>
      <button
        *ngIf="!hideButton"
        nz-button
        class="login-form-button login-form-margin"
        [nzType]="'primary'"
        [nzLoading]="isLoading"
        (click)="submitForm()"
      >
        <i nz-icon>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24.47 24.32">
            <g id="Layer_2" data-name="Layer 2">
              <g id="Layer_1-2" data-name="Layer 1">
                <rect
                  x="19.63"
                  y="8.73"
                  width="1.5"
                  height="6.85"
                  style="fill: #fff"
                />
                <rect
                  x="22.97"
                  y="7.88"
                  width="1.5"
                  height="8.55"
                  style="fill: #fff"
                />
                <path
                  d="M10.81,3.87a1.51,1.51,0,1,0,1.5,1.52A1.52,1.52,0,0,0,10.81,3.87Z"
                  style="fill: #fff"
                />
                <path
                  d="M14.92,0h-11V3.47h0V8.78L.59,12.14h0L0,12.71V24.32H4.27L8,20.57l0,0L10.56,18a1.51,1.51,0,0,0-2.14-2.14L5.9,18.41V2h9.81V20.55H10.82l-2,2h8.83V0Z"
                  style="fill: #fff"
                />
              </g>
            </g>
          </svg>
        </i>
        {{ "Sign in" | locale }}
      </button>
    </nz-space-item>
    <nz-space-item style="text-align: center">
      <a (click)="showResetModal()">{{ "Forgot password" | locale }}</a>
      <a
        *ngIf="signupLink != null && signupLink !== ''"
        [href]="signupLink"
        target="_blank"
      >
        | {{ "Sign-up" | locale }}</a
      >
    </nz-space-item>
    <nz-space-item
      style="text-align: center"
      *ngIf="!hideTitle && displayLandingPageLink"
    >
      <nz-divider [nzText]="'or' | locale"></nz-divider>
    </nz-space-item>
    <nz-space-item *ngIf="!hideTitle && displayLandingPageLink">
      <a nz-button nzType="link" nzBlock="true" (click)="direct('i')">
        {{ "Login via employee portal" | locale }}
      </a>
    </nz-space-item>

    <nz-space-item style="text-align: center;">
      <a *ngIf="androidAppLink != null && androidAppLink !== undefined && androidAppLink !== ''"
        [href]="androidAppLink"
        target="_blank"
      >
        <img style="width: 40%"
          src="assets/Google_Play.png"
        />
      </a>
      <a *ngIf="appleAppLink != null && appleAppLink !== undefined && appleAppLink !== ''"
        [href]="appleAppLink"
        target="_blank"
      >
        <img style="width: 40%"
          src="assets/App_Store.png"
        />
      </a>
    </nz-space-item>

  </nz-space>
</div>
<div class="company-list" *ngIf="showCompanies">
  <nz-result
    nzStatus="error"
    [nzTitle]="
      'Please contact our customer service, you do not have accounts assigned with your login.'
        | locale
    "
    *ngIf="response.company.length === 0"
  >
    <div nz-result-content>
      <button nz-button (click)="showCompanies = false">
        {{ "Login with different account" | locale }}
      </button>
    </div>
  </nz-result>
  <nz-list
    nzBordered
    [nzLoading]="isLoading"
    *ngIf="response.company.length !== 0"
  >
    <nz-list-item
      *ngFor="let company of response.company; let i = index"
      (click)="login(company)"
    >
      <nz-list-item-meta>
        <nz-list-item-meta-title>
          <i class="fal fa-building"></i>
          {{ response.CompanyUsers[i].CardName }}<br />
          <i class="fal fa-user-tie"></i>
          {{ response.CompanyUsers[i].CntctFirstName }}
          {{ response.CompanyUsers[i].CntctLastName }}
          <br />
          <span style="color: var(--bweb-primary)">{{
            company.companyName
          }}</span>
        </nz-list-item-meta-title>
      </nz-list-item-meta>
    </nz-list-item>
  </nz-list>
</div>

<nz-modal
  [(nzVisible)]="isResetVisible"
  [nzTitle]="'Password Reset' | locale"
  (nzOnCancel)="isResetVisible = false"
  (nzOnOk)="reset()"
>
  <nz-form-item>
    <nz-form-label>
      {{ "Email" | locale }}
    </nz-form-label>
    <nz-form-control>
      <input type="text" nz-input [(ngModel)]="resetEmail" />
    </nz-form-control>
  </nz-form-item>
</nz-modal>
